export default __webpack_public_path__ + "static/mofad-logo-text-b2d740b1aa2c58c93ca25df7747aebee.png";